<script>
  import { onDestroy, onMount } from 'svelte'

  let currDT = new Date()
  let clock
  onMount(() => {
    function updateClock() {
      // console.log('updating clock')
      currDT = new Date()
    }
    function startClock(millis) {
      // console.log('starting clock')
      updateClock()
      clock = setInterval(updateClock, millis)
    }
    updateClock()
    let tOffset =
      60000 - (currDT.getSeconds() * 1000 + currDT.getMilliseconds())
    // console.log({ tOffset })
    setTimeout(startClock, tOffset, 60000)
  })
  onDestroy(() => {
    // console.log('destroying clock')
    clearInterval(clock)
  })
</script>

<div class="container">
  {currDT.toLocaleDateString(undefined, { timeZone: 'Europe/Berlin' })}
  {currDT.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Berlin',
    timeZoneName: 'short',
  })}
</div>

<style lang="scss">
  .container {
    @include typo-grotesk-title-captions-20;
    color: $color-mint;
    text-shadow: $text-glow;
  }
</style>
